export const suggestions = [
  "Why do I slice it?",
  "How do I hit it further?",
  "What are the differences between my good and bad swings?",
  "How does my swing compare to Bryson's?",
  "Roast my swing",
];

export const ROOT_INTENTS = {
  SPEED: "speed",
  TILES: "tiles",
  IMPROVEMENT: "improvement",
  COMPARE: "compare",
  CORRELATION: "correlation",
  GENERIC: "generic",
};

export const FOLLOW_UPS_BY_INTENT = {
  // [ROOT_INTENTS.SPEED]: [
  //   "What are the top 10 highest correlated items to spin axis for data only at top of backswing?",
  // ],
  // [ROOT_INTENTS.TILES]: [
  //   "What are the top 10 highest correlated items to spin axis for data only at top of backswing?",
  // ],
  // [ROOT_INTENTS.IMPROVEMENT]: [
  //   "What are the top 10 highest correlated items to spin axis for data only at top of backswing?",
  // ],
  // [ROOT_INTENTS.COMPARE]: [
  //   "Compared to the goldset, what are the top 10 most standardized different things?",
  //   "What are the values from each dataset for these variables?",
  //   "What are the top 10 most standardized differences at impact?",
  //   "What is the standardized difference and values for Lead Wrist Rad-Uln Deviation at top of backswing?",
  // ],
  // [ROOT_INTENTS.CORRELATION]: [
  //   "What are the top 10 highest correlated items to spin axis?",
  //   "What are the top 10 highest correlated items to spin axis for data only at top of backswing?",
  //   "What are the data ranges for the top 10 correlated indicators to spin axis only at top of backswing?",
  //   "What are the data ranges for the top 10 correlated indicators to spin axis only at impact?",
  // ],
  // [ROOT_INTENTS.GENERIC]: [
  //   "What are the top 10 highest correlated items to spin axis for data only at top of backswing?",
  // ],
};
